import { Flex, Text, Input, Skeleton } from '@noahswap/uikit'
import styled from 'styled-components'
import { useTranslation } from '@noahswap/localization'
import { PoolData } from 'state/info/types'
import { SetStateAction, Dispatch, Fragment, useState } from 'react'
import { NextLinkFromReactRouter } from 'components/NextLink'
import { DoubleCurrencyLogo } from 'views/Info/components/CurrencyLogo'
import { formatAmount, formatPrice, formatUsd, formatNumber } from 'utils/formatInfoNumbers'
import { ITEMS_PER_INFO_TABLE_PAGE } from 'config/constants/info'
import { Break } from 'views/Info/components/InfoTables/shared'

const QuotationMobileWrap = styled.div`
  background-color: #fff;
  border-radius: 20px;
  min-height: 200px;
  padding: 14px 0;
`

const StyledInput = styled(Input)<{ inputBlur?: boolean }>`
  width: 142px;
  height: 33px;
  z-index: 9999;
  padding-left: 36px;
  border: 1px solid;
  border-color: #e9e9e9 !important;
  font-size: 12px;
  color: #000;
  border-radius: 5px;
  height: 28px;
  border-color: ${({ inputBlur }) => (inputBlur ? '#000' : '#e9e9e9')};
`

const SearchDeleteIcon = styled.div`
  position: absolute;
  right: 12px;
  top: 45%;
  transform: translateY(-50%);
  z-index: 10;
  cursor: pointer;
  color: #000;
`
const ResponsiveGrid = styled.div<{ tableHead?: boolean }>`
  display: grid;
  grid-gap: 0;
  align-items: center;
  /* grid-template-columns: 33px 3fr repeat(2, 2fr); */
  grid-template-columns: 2fr repeat(2, 2fr);
  background: ${({ tableHead }) => (tableHead ? '#F2F2F2' : '#fff')};

  margin-top: ${({ tableHead }) => (tableHead ? '10px' : '3px')};
  border-radius: ${({ tableHead }) => (tableHead ? '8px' : '0px')};
  text-align: center;
`

const LinkWrapper = styled(NextLinkFromReactRouter)`
  text-decoration: none;
  :hover {
    cursor: pointer;
    opacity: 0.7;
  }
`

const ChangeBtn = styled.div<{ priceChange: any }>`
  width: 86%;
  height: 34px;
  line-height: 34px;
  font-weight: bold;
  text-align: center;
  font-size: 13px;
  background-color: ${({ priceChange }) => (priceChange > 0 ? '#17BA78' : priceChange === 0 ? '#999' : 'red')};
  border-radius: 10px;
  color: #fff;
`

const SearchLogo = styled.img`
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
`

const FlexRow = styled.div<{ active: boolean }>`
  cursor: pointer;
  background: ${({ active }) => (active ? '#FAD436' : '#fff')};
  border-width: 1px;
  border-style: solid;
  font-size: 14px;
  padding: 3px 10px;
  border-radius: 6px;
  border-color: ${({ active }) => (active ? '#14162A' : '#fff')};
  margin-right: 10px;
`

const DataRow = ({ poolData, index }: { poolData: any; index: number }) => {
  const { t } = useTranslation()
  const priceChange =
    poolData.priceChange > 0
      ? `+${poolData.priceChange.toFixed(2)}`
      : poolData.priceChange === 0
      ? '0.00'
      : `${poolData.priceChange.toFixed(2)}`
  let symbolChange = {
    token0: poolData?.token0,
    token1: poolData?.token1,
  }
  if (poolData?.direction === 1) {
    symbolChange = {
      token0: poolData?.token1,
      token1: poolData?.token0,
    }
  }
  // const symbolArr = ['DAI', 'USDT', 'USDC']
  // if (poolData?.token0?.symbol === 'WEOS' && !symbolArr.find((item) => item === poolData?.token1?.symbol)) {
  //   symbolChange = {
  //     token0: poolData?.token1,
  //     token1: poolData?.token0,
  //   }
  // }
  return (
    <LinkWrapper to={`/info/pools/${poolData.address}`}>
      <ResponsiveGrid>
        <Flex justifyContent="center" alignItems="center" flexDirection="column" style={{ height: '25px' }}>
          <Flex alignItems="center" style={{ placeSelf: 'flex-start' }}>
            {/* <DoubleCurrencyLogo token0={symbolChange.token0} size={33} /> */}
            <Flex>
              <Text mb="4px" fontSize="14px" fontWeight="900">
                {symbolChange?.token0?.symbol}{' '}
              </Text>
              <Text color="#92929B" fontSize="14px" fontWeight="900">
                /{symbolChange?.token1?.symbol}
              </Text>
            </Flex>
            {/* {poolData.address === '0x2dfada2212e534b7e234fb877dca4ddcaef049b7' && ( */}
            {poolData.newPair && (
              <Flex style={{ marginLeft: '4px', position: 'relative', top: '-2px' }}>
                <img src="/images/ad/new.png" alt="" width="24" style={{ objectFit: 'contain' }} />
              </Flex>
            )}
          </Flex>
          <Flex style={{ placeSelf: 'flex-start' }}>
            {/* 成交额 */}
            <Text fontSize="12px" color="#92929B">
              {t('noah194')} ${formatAmount(poolData.volumeUSD)}
            </Text>
          </Flex>
        </Flex>
        <Flex alignItems="center" flexDirection="column">
          <Text mb="4px" fontSize="14px" fontWeight="900">
            {formatNumber(formatPrice(poolData.price), poolData.price)}
          </Text>
          {poolData?.priceUsd ? (
            <Text fontSize="12px" color="#92929B">
              ${formatNumber(formatUsd(poolData.priceUsd), poolData.priceUsd)}
            </Text>
          ) : (
            <Text fontSize="12px" color="#92929B">
              &nbsp;
            </Text>
          )}
        </Flex>
        <Flex alignSelf="flex-start" flexDirection="row-reverse" pt="4px">
          <ChangeBtn priceChange={poolData.priceChange}>{priceChange}%</ChangeBtn>
        </Flex>
      </ResponsiveGrid>
    </LinkWrapper>
  )
}

interface QuotationTableProps {
  poolDatas: PoolData[]
  loading?: boolean // If true shows indication that SOME pools are loading, but the ones already fetched will be shown
  title?: string
  searchValue?: string
  setSearchValue?: Dispatch<SetStateAction<string>>
  tableType?: number
  setTableType?: Dispatch<SetStateAction<number>>
}
const LoadingRow: React.FC<React.PropsWithChildren> = () => (
  <ResponsiveGrid style={{ padding: '0 20px' }}>
    <Skeleton />
    <Skeleton />
    <Skeleton />
  </ResponsiveGrid>
)

const TableLoader: React.FC<React.PropsWithChildren> = () => (
  <>
    <LoadingRow />
    <LoadingRow />
    <LoadingRow />
    <LoadingRow />
  </>
)

const QuotationMobile: React.FC<React.PropsWithChildren<QuotationTableProps>> = ({
  poolDatas,
  loading,
  title,
  searchValue,
  setSearchValue,
  tableType,
  setTableType,
}) => {
  const [inputBlur, setInputBlur] = useState(false)
  const { t } = useTranslation()
  const handleSearchValue = (e) => {
    setSearchValue(e.target.value)
  }
  const handleTab = (id) => {
    setTableType(id)
  }
  const poolDatass = poolDatas?.sort((a, b): any => {
    return b?.usdBalance2 - a?.usdBalance2
  })

  const tabArr = [
    {
      id: 0,
      label: t('noah92'),
    },
    {
      id: 1,
      label: 'EOS',
    },
    {
      id: 2,
      label: t('noah196'),
    },
  ]

  return (
    <QuotationMobileWrap>
      <Flex justifyContent="space-between" style={{ marginBottom: '14px', padding: '0 20px' }}>
        <Flex>
          <Text color="#000" fontSize="20px" bold style={{ lineHeight: '30px' }}>
            {title}
          </Text>
        </Flex>
        <div style={{ position: 'relative' }}>
          <SearchLogo src="/images/small-img/icon3.png" width={16} alt="" />
          <div style={{ position: 'relative' }}>
            <StyledInput
              type="text"
              onFocus={() => setInputBlur(true)}
              onBlur={() => setInputBlur(false)}
              inputBlur={inputBlur}
              value={searchValue}
              onChange={handleSearchValue}
              placeholder={t('noah100')}
            />
            {searchValue && <SearchDeleteIcon onClick={() => setSearchValue('')}>×</SearchDeleteIcon>}
          </div>
        </div>
      </Flex>
      <Flex justifyContent="space-between" alignItems="center" style={{ marginBottom: '18px', padding: '0 20px' }}>
        {!searchValue ? (
          <Flex>
            {tabArr.map((v) => {
              return (
                <FlexRow key={v.id} active={v.id === tableType} onClick={() => handleTab(v.id)}>
                  {v.label}
                </FlexRow>
              )
            })}
          </Flex>
        ) : (
          <Flex>
            <Text fontSize="14px" color="#92929B">
              {t('%num% results found', { num: poolDatas?.length })}
            </Text>
          </Flex>
        )}
      </Flex>
      <Flex justifyContent="space-between" style={{ marginBottom: '18px', padding: '0 20px' }}>
        <Text fontSize="12px" color="#92929B">
          {t('noah37')}
        </Text>
        <Text fontSize="12px" color="#92929B">
          {t('noah81')}
        </Text>
        <Text fontSize="12px" color="#92929B">
          {t('noah91')}
        </Text>
      </Flex>
      {/* <Flex justifyContent="space-around" /> */}
      {loading ? (
        <TableLoader />
      ) : poolDatass?.length ? (
        <div style={{ height: '70vh', overflow: 'auto', padding: '0 10px 0 20px' }}>
          {poolDatass.map((poolData, i) => {
            return (
              <Fragment key={poolData.address}>
                <DataRow index={i} poolData={poolData} />
                {i !== poolDatass?.length - 1 ? (
                  <Break style={{ margin: '24px 0' }} />
                ) : (
                  <div style={{ marginBottom: '10px' }} />
                )}
              </Fragment>
            )
          })}
        </div>
      ) : (
        <Flex
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          style={{ height: '200px', lineHeight: '200px' }}
        >
          <Text textAlign="center" bold maxWidth="400px" fontSize="16px" mb="16px">
            <img src="/images/small-img/noData.png" width={80} alt="" />
            <Text textAlign="center" maxWidth="400px" fontSize="16px" mt="16px" color="#85868A">
              {t('noah116')}
            </Text>
          </Text>
        </Flex>
      )}
    </QuotationMobileWrap>
  )
}

export default QuotationMobile
